import { FetchRequestError } from "./FetchRequestError";

export class FetchSsoError extends FetchRequestError {
  /**
   * Backend-intended user flow: the company requires SSO and the request was
   * rejected so the user can be redirected to their identity provider.
   * Suppress from RUM/Sentry to avoid inflating monitoring with non-actionable
   * events.
   */
  override isUnexpectedSystemError(): boolean {
    return false;
  }
}
